<template>
  <div v-if="preguntas">
    <md-sidenav @close="close()" class="md-right feedback-detail" ref="rightSidenav">
      <md-toolbar>
         <div class="md-toolbar-container">
            <h3 class="md-title">Feedback de {{feedback.owner}} por {{feedback.editor}}</h3>
            <md-button @click.native="closeRightSidenav()" class="md-icon-button close-feedback">
                <md-icon>close</md-icon>
            </md-button>
         </div>
      </md-toolbar>
      
      <md-list class="form-question" >
         <md-list-item v-for="preg in preguntas" :key="preg.key">
            <div class="md-list-text-container">
                <p class="md-center question">{{preg.question}}</p>
                <md-input-container md-inline>
                    <md-textarea v-model.trim="preg.answer" readonly class="answer"></md-textarea>
                </md-input-container>
            </div>
         </md-list-item>
      </md-list>
      <div class="container-buttons">
        <md-button class="md-raised md-primary" @click.native="closeRightSidenav">Ok</md-button>
        <md-button v-if="feedback.completed" class="md-raised md-primary" @click.native="editable()">Volver a editar</md-button>
        <md-button v-if="!feedback.completed" class="md-raised md-primary" @click.native="openConfirm('delete-feedback')">Eliminar</md-button>        
      </div>
    </md-sidenav>

    <md-dialog-confirm
        :md-title="''"
        :md-content-html="'Se va a eliminar el Feedback, esta operacion no puede ser revertida, desea continuar?'"
        :md-ok-text="'Eliminar'"
        :md-cancel-text="'cancelar'"
        @close="eliminar"
        ref="delete-feedback">
    </md-dialog-confirm>       

  </div>
</template>

<script>
import FeedbacksService from '../services/feedbacks'
import Router from '../router'

export default {
  name: 'feedback-detail-admin',
  data () {
    return {
      feedback: this.$route.params.feedback
    }
  },
  mounted: function () {
    this.$refs.rightSidenav.toggle()
  },
  firebase: function () {
    return {
      preguntas: FeedbacksService.getPreguntasById(this.$route.params.id)
    }
  },
  methods: {
    closeRightSidenav () {
      this.$refs.rightSidenav.close()
    },
    close () {
      Router.go(-1)
    },
    openConfirm (ref) {
      this.$refs[ref].open()
    },
    editable () {
      FeedbacksService.guardar(this.$route.params.id, this.preguntas)
      this.$refs.rightSidenav.close()
    },
    eliminar (type) {
      if (type === 'ok') {
        FeedbacksService.eliminar(this.feedback).then(() => {
          this.$refs.rightSidenav.close()
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

    .close-feedback {
        right: 0;
        position: absolute !important;
    }

    .answer {
      overflow: auto !important
    }
</style>



// WEBPACK FOOTER //
// FeedbackDetailAdmin.vue?b252ff7e